import { Component, input } from '@angular/core';
import { BUTTON_TEXTS } from '../../../constants/buttons.constants';
import { OfferingOnboardingStep } from '../../../models/offering';
import { RouterModule } from '@angular/router';
import {
  RdsCardModule,
  RdsIconsModule,
  RdsButtonModule,
  RdsLinkModule,
} from '@rds/angular-components';
import { DynamicModule } from 'ng-dynamic-component';

@Component({
  selector: 'inexp-offering-onboarding-steps',
  imports: [
    RdsCardModule,
    RdsIconsModule,
    RdsButtonModule,
    DynamicModule,
    RdsLinkModule,
    RouterModule,
  ],
  templateUrl: './offering-onboarding-steps.component.html',
  styleUrl: './offering-onboarding-steps.component.scss',
})
export class OfferingOnboardingStepsComponent {
  _uid = input<string>();
  component = input<string>();
  section = input<any>();
  onboardingSteps = input<OfferingOnboardingStep[]>();
  onboardingAccessInstructions = input<string>();

  BUTTONS = BUTTON_TEXTS;
}
